import React, { useState, useRef } from 'react';
import ProductInfo from './ProductInfo';
import EspecificacionesTecnicasSection from './EspecificacionesTecnicasSection';
import AyudaSection from './AyudaSection';
import ModalVideo from 'react-modal-video';
import useFetch from 'core/hooks/api/useFetch';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';
import { all_routes } from 'core/data/routes/all_routes';
import FeaturedItemV2 from '../slides/featured-product-categories-artectum';
import './ProductDetails.css'; // Import the CSS file for placeholder animations
import { Helmet } from 'react-helmet';

const img_api = process.env.REACT_APP_IMG_API;

const ProductDetails = ({ productId }) => {
    const { data: product, loading } = useFetch(`${API_ENDPOINTS.PRODUCTS}/${productId}`);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [zoomStyle, setZoomStyle] = useState({});
    const zoomRef = useRef(null);
    const routes = all_routes;

    const images = [
        ...product?.product_option?.filter(option => option.url && (option.url.endsWith('.jpg') || option.url.endsWith('.png'))).map(option => ({ ...option, src: option.url })) || [],
        ...product?.photos?.map(photo => ({ ...photo, src:photo.src })) || [],
        ...product?.applied_photos?.map(photo => ({ ...photo, src: photo.src })) || []
    ];

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const handleHover = (image) => {
        const index = images.findIndex(img => img.src === image.src);
        if (index !== -1) {
            setCurrentImageIndex(index);
        }
    };

    const handleOptionChange = (option, index) => {
        setSelectedOption(selectedOption?.id === option?.id ? null : option);
        setCurrentImageIndex(images.findIndex(img => img.src === option.url));
    };

    const handleMouseMove = (e) => {
        if (window.innerWidth <= 767) return; // Disable zoom for mobile devices
        requestAnimationFrame(() => {
            const { left, top, width, height } = zoomRef.current.getBoundingClientRect();
            const x = ((e.pageX - left) / width) * 100;
            const y = ((e.pageY - top) / height) * 100;
            setZoomStyle({
                transformOrigin: `${x}% ${y}%`,
                transform: 'scale(1.8)',
                transition: 'transform 0.2s ease, transform-origin 0.2s ease',
            });
        });
    };

    const handleMouseEnter = () => {
        if (window.innerWidth <= 767) return; // Disable zoom for mobile devices
        setZoomStyle((prevStyle) => ({
            ...prevStyle,
            opacity: 1,
        }));
    };

    const handleMouseLeave = () => {
        if (window.innerWidth <= 767) return; // Disable zoom for mobile devices
        setZoomStyle({});
    };

    const handleButtonMouseEnter = () => {
        setZoomStyle({});
    };

    const handleButtonMouseLeave = () => {
        setZoomStyle((prevStyle) => ({
            ...prevStyle,
            transform: 'scale(2)',
            transition: 'transform 0.2s ease, transform-origin 0.2s ease',
        }));
    };

    return (
        <div className="ltn__product-area ltn__product-gutter d-flex justify-content-center">
            <Helmet>
                <title>Baldosas, Terrazos y Mosaicos en Lima | Artectum</title>
                <meta name="description" content="Encuentra baldosas, mosaicos, celosías y terrazos de concreto de alta calidad para proyectos residenciales y comerciales. Cotiza con nosotros." />
            </Helmet>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        {loading ? (
                            <div className="placeholder-container row">
                                <div className="placeholder-breadcrumb"></div>
                                <div className="row mt-2 mt-md-4 d-flex justify-content-center">
                                    <div className="col-lg-5 pe-0 col-12 d-flex justify-content-start flex-column">
                                        <div className="placeholder-image"></div>
                                    </div>
                                    <div className="col-lg-6 col-12">
                                        <div className="placeholder-info"></div>
                                    </div>
                                </div>
                                <div className="row mt-3 mt-md-5 d-flex justify-content-center">
                                    <div className="col-lg-5 pe-0 col-12 d-flex justify-content-start flex-column">
                                        <div className="placeholder-section"></div>
                                    </div>
                                    <div className="col-lg-6 col-12">
                                        <div className="placeholder-video"></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                {product && (
                                    <nav aria-label="breadcrumb mt-5">
                                        <ol className="breadcrumb mt-3">
                                            <li className="breadcrumb-item mt-5 mt-0" style={{ cursor: 'pointer', marginTop: '10px ' }}>
                                                <button className="btn p-0" onClick={() => window.history.back()}>
                                                    <i className="fas fa-arrow-left"></i>
                                                </button>
                                            </li>
                                            <li className="breadcrumb-item mt-0"><a href="/">Home</a></li>
                                            <li className="breadcrumb-item mt-0"><a href={routes.product}>Productos</a></li>
                                            <li className="breadcrumb-item mt-0 active" aria-current="page">
                                                {product.title.length > 20 ? `${product.title.substring(0, 20)}...` : product.title}
                                            </li>
                                        </ol>
                                    </nav>
                                )}
                                <div className="row mt-2 mt-md-4 d-flex justify-content-center">
                                    <div className="col-lg-5 pe-0 col-12 d-flex justify-content-start flex-column">
                                        {images.length > 0 && (
                                            <div className="d-flex">
                                                <div className="thumbnail-navigation scroll-none p-0 d-flex justify-content-center d-none d-md-block" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                    <ul className="list-unstyled m-0">
                                                        {images.map((image, index) => (
                                                            <li className="mb-3 mt-0" style={{ width: '67px', height: '67px' }} key={index} onMouseEnter={() => handleHover(image)}>
                                                                <ImageWithBaseApi
                                                                    loadingIconFontSize="20px"
                                                                    src={image.src}
                                                                    alt={`Thumbnail ${index + 1}`}
                                                                    className="w-100 h-100"
                                                                    style={{ objectFit: 'cover', cursor: 'pointer', transition: 'transform 0.3s' }}
                                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.04)'}
                                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                                />
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                <div className="w-100 h-100 position-relative" style={{ maxWidth: '400px', maxHeight: '400px' }}>
                                                    <button 
                                                        onClick={handlePrevImage} 
                                                        className="btn theme-btn-6 position-absolute" 
                                                        style={{ top: '50%', left: '0px', transform: 'translateY(-50%)', fontSize: '30px', fontWeight: '600' }}
                                                        onMouseEnter={handleButtonMouseEnter}
                                                        onMouseLeave={handleButtonMouseLeave}
                                                    >
                                                        &lt;
                                                    </button>
                                                    {images[currentImageIndex] && (
                                                        <div
                                                            className="product-image w-100 h-100"
                                                            ref={zoomRef}
                                                            onMouseMove={handleMouseMove}
                                                            onMouseEnter={handleMouseEnter}
                                                            onMouseLeave={handleMouseLeave}
                                                            style={{ overflow: 'hidden', position: 'relative' }}
                                                        >
                                                            <img
                                                                src={`${img_api}${images[currentImageIndex].src}`}
                                                                alt="Product"
                                                                style={{ width: '100%', height: '100%', objectFit: 'contain', ...zoomStyle, transition: 'transform 0.2s ease, transform-origin 0.2s ease' }}
                                                            />
                                                        </div>
                                                    )}
                                                    <button 
                                                        onClick={handleNextImage} 
                                                        className="btn theme-btn-6 position-absolute" 
                                                        style={{ top: '50%', right: '0px', transform: 'translateY(-50%)', fontSize: '30px', fontWeight: '600' }}
                                                        onMouseEnter={handleButtonMouseEnter}
                                                        onMouseLeave={handleButtonMouseLeave}
                                                    >
                                                        &gt;
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-lg-6 col-12">
                                        <ProductInfo 
                                            product={product} 
                                            selectedOption={selectedOption} 
                                            handleOptionChange={handleOptionChange} 
                                            selectedSize={selectedSize}
                                            setSelectedSize={setSelectedSize} // Add this line
                                        />
                                    </div>
                                </div>
                                <div className="row mt-3 mt-md-5 col-12 d-flex justify-content-start">
                                    {product?.specifications?.length > 0 && (
                                        <div className={product?.help ? "col-md-6 col-12" : "col-md-12 col-12"}>
                                            <EspecificacionesTecnicasSection product={product} />
                                        </div>
                                    )}
                                    {product?.help && (
                                        <div className={product?.specifications?.length > 0 ? "col-md-6 col-12" : "col-md-6 col-12"}>
                                            <AyudaSection product={product} setIsOpen={setIsOpen} />
                                        </div>
                                    )}
                                </div>
                                <div className="row mt-3 mt-md-5 col-12 d-flex justify-content-center">
                                    <div className="col-lg-6 col-12">
                                        {product?.help && (
                                            <ModalVideo channel='youtube' isOpen={isOpen} videoId={product?.help.video_id.split('v=')[1]} onClose={() => setIsOpen(false)} />
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <FeaturedItemV2 categoryId={product?.category_id} />
            </div>
        </div>
    );
}

export default ProductDetails;